'use client';

import { useState } from 'react';
import { Menu, X } from 'lucide-react';

export default function MobileMenu({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false);

  return (
    <div className='md:hidden'>
      <button
        type='button'
        aria-label={open ? 'Close menu' : 'Open menu'}
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
        className='block text-fg'
      >
        {open ? <X size={24} /> : <Menu size={24} />}
      </button>
      {open && (
        <div
          onClick={() => setOpen(false)}
          className='bg-bg fixed inset-0 top-[80px] flex flex-col items-center justify-center gap-[30px] text-xl font-bold uppercase tracking-wide'
        >
          {children}
        </div>
      )}
    </div>
  );
}
